const baseFontSize = 16;
const rem = (value) => `${value / baseFontSize}rem`;
const getFocusTokens = (mainColors) => ({
    focus: `0 0 0 ${rem(4)} ${mainColors.piccolo}20`,
});
export default getFocusTokens;
